import React from "react"
import ActuItem from "../ActuItem/actu-item"
import PropTypes from "prop-types"

const RenderActualites = ({ actualiteData, colors }) => {
  return (
    <>
      {actualiteData.slice(0, 2).map(({ node }) => {
        return <ActuItem colors={colors} key={node.drupal_id} actu={node} />
      })}
    </>
  )
}

RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

export default RenderActualites
